import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Modal, Btn, Select } from "@/components/erp/ui";
import { HardDriveDownload } from "lucide-react";
import { fmtDT } from "@/components/erp/prod/HeadWoCard";

// Backup file produksi (ZIP) ke hardisk eksternal sebelum terhapus otomatis
export const BackupModal = ({ open, onClose }) => {
  const [within, setWithin] = useState(14);
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/prod/files/expiring", { params: { within } }).then(({ data }) => setD(data)).catch(() => setD({ items: [] }));
  useEffect(() => { if (open) { load(); } }, [open, within]); // eslint-disable-line react-hooks/exhaustive-deps
  const download = async () => {
    setBusy(true);
    try {
      const r = await api.get("/prod/files/backup.zip", { params: { within }, responseType: "blob" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(r.data);
      a.download = (r.headers["content-disposition"] || "").split("filename=")[1] || "backup-file-produksi.zip";
      a.click(); URL.revokeObjectURL(a.href);
      toast.success("Backup diunduh — simpan ke hardisk eksternal"); load();
    } catch { toast.error("Gagal membuat backup"); } finally { setBusy(false); }
  };
  const items = d?.items || [];
  return (
    <Modal open={open} onClose={onClose} wide title="Backup File Produksi"
      footer={<Btn data-testid="backup-download" disabled={busy || !items.length} onClick={download}><HardDriveDownload className="w-4 h-4" /> {busy ? "Menyiapkan ZIP…" : `Download ${items.length} file (ZIP)`}</Btn>}>
      <p className="text-xs text-slate-500 mb-3">File produksi terhapus otomatis {d?.retention_days ?? "—"} hari setelah diupload (catatan job tetap tersimpan). Download ZIP lalu pindahkan ke hardisk eksternal. Lama simpan diatur admin utama di tab Spool & Stiker → Pengaturan produksi.</p>
      <div className="w-56 mb-3"><Select data-testid="backup-within" value={within} onChange={(e) => setWithin(+e.target.value)}>
        <option value={7}>Terhapus ≤ 7 hari lagi</option><option value={14}>Terhapus ≤ 14 hari lagi</option><option value={30}>Terhapus ≤ 30 hari lagi</option><option value={-1}>Semua file tersimpan</option>
      </Select></div>
      <div className="space-y-1 max-h-[50vh] overflow-y-auto" data-testid="backup-list">
        {!items.length && <p className="text-sm text-slate-400">Tidak ada file.</p>}
        {items.map((j) => (
          <div key={j.id} className="flex flex-wrap gap-2 text-sm border-t border-slate-100 pt-1" data-testid={`backup-item-${j.id}`}>
            <span className="font-mono text-xs text-slate-500">{j.wo_code}</span><span className="flex-1 truncate">{j.prod_file_name || j.file_name}</span>
            <span className={`text-xs ${j.days_left <= 7 ? "text-rose-600" : "text-slate-500"}`}>terhapus {fmtDT(j.expires_at)} ({j.days_left} hari)</span>
            <span className="text-xs text-emerald-700">{j.backup_at ? `backup ${fmtDT(j.backup_at)}` : ""}</span>
          </div>
        ))}
      </div>
    </Modal>
  );
};
